import alertSettingsService from '../../services/alertSettingsService';

export const FETCH_ALERT_SETTINGS_REQUEST = 'FETCH_ALERT_SETTINGS_REQUEST';
export const FETCH_ALERT_SETTINGS_SUCCESS = 'FETCH_ALERT_SETTINGS_SUCCESS';
export const FETCH_ALERT_SETTINGS_FAILURE = 'FETCH_ALERT_SETTINGS_FAILURE';
export const UPDATE_ALERT_SETTINGS_REQUEST = 'UPDATE_ALERT_SETTINGS_REQUEST';
export const UPDATE_ALERT_SETTINGS_SUCCESS = 'UPDATE_ALERT_SETTINGS_SUCCESS';
export const UPDATE_ALERT_SETTINGS_FAILURE = 'UPDATE_ALERT_SETTINGS_FAILURE';

export const fetchAlertSettings = () => async (dispatch) => {
  dispatch({ type: FETCH_ALERT_SETTINGS_REQUEST });
  try {
    const data = await alertSettingsService.getSettings();
    dispatch({ type: FETCH_ALERT_SETTINGS_SUCCESS, payload: data.settings });
  } catch (error) {
    dispatch({ type: FETCH_ALERT_SETTINGS_FAILURE, payload: error.response?.data?.message || 'Erreur de chargement' });
  }
};

export const saveAlertSettings = (settings) => async (dispatch) => {
  dispatch({ type: UPDATE_ALERT_SETTINGS_REQUEST });
  try {
    const data = await alertSettingsService.updateSettings(settings);
    dispatch({ type: UPDATE_ALERT_SETTINGS_SUCCESS, payload: data.settings });
  } catch (error) {
    dispatch({ type: UPDATE_ALERT_SETTINGS_FAILURE, payload: error.response?.data?.message || 'Erreur de sauvegarde' });
  }
};
